/* Outside-click + Escape closer for the native <details> country/currency
   selectors (.nav-loc). Native <details> handles open/close + keyboard;
   this just closes an open dropdown when you click away or press Escape. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('details[data-nav-loc][open]');
    Array.prototype.forEach.call(open, function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('details[data-nav-loc][open]');
    Array.prototype.forEach.call(open, function (d) {
      d.removeAttribute('open');
      var summary = d.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();
